<button
  class="form-item-button"
  mat-mini-fab
  (click)="clearAll()"
  [disabled]="!this.selectedCategory && !this.selectedSubCategory && !this.selectedTier && !this.selectedItem"
  color="primary"
  aria-label="Clear All Button"
>
  <mat-icon>cancel</mat-icon>
</button>
<mat-form-field class="form-item-medium" appearance="fill">
  <mat-label>Category </mat-label>
  <mat-select [(ngModel)]="selectedCategory">
    <mat-option>
      <ngx-mat-select-search
        ngModel
        (ngModelChange)="filterShopCategories($event)"
        placeholderLabel="Search"
        noEntriesFoundLabel="No matches"
      ></ngx-mat-select-search>
    </mat-option>
    @for (category of filteredShopCategories; track category) {
      <mat-option [value]="category">
        <span class="mat-option">{{ category.displayName }}</span>
      </mat-option>
    }
    <mat-select-trigger>
      <div class="trigger-container">
        {{ selectedCategory ? selectedCategory.displayName : '' }}
        @if (selectedCategory) {
          <button mat-icon-button class="clear-button" (click)="selectedCategory = null" aria-label="Clear Selected Gategory">
            <mat-icon>close</mat-icon>
          </button>
        }
      </div>
    </mat-select-trigger>
  </mat-select>
</mat-form-field>
<mat-form-field class="form-item-medium" appearance="fill">
  <mat-label>Sub-Category</mat-label>
  <mat-select [(ngModel)]="selectedSubCategory" disabled="{{ !selectedCategory }}">
    <mat-option>
      <ngx-mat-select-search
        ngModel
        (ngModelChange)="filterShopSubCategories($event)"
        placeholderLabel="Search"
        noEntriesFoundLabel="No matches"
      ></ngx-mat-select-search>
    </mat-option>
    @for (subCategory of filteredShopSubCategories; track subCategory) {
      <mat-option [value]="subCategory">
        <span class="mat-option">{{ subCategory.displayName }}</span>
      </mat-option>
    }
    <mat-select-trigger>
      <div class="trigger-container">
        {{ selectedSubCategory ? selectedSubCategory.displayName : '' }}
        @if (selectedSubCategory) {
          <button mat-icon-button class="clear-button" (click)="selectedSubCategory = null" aria-label="Clear Selected Sub Category">
            <mat-icon>close</mat-icon>
          </button>
        }
      </div>
    </mat-select-trigger>
  </mat-select>
</mat-form-field>
<mat-form-field class="form-item-small" appearance="fill">
  <mat-label>Tier</mat-label>
  <mat-select [(ngModel)]="selectedTier">
    @for (tier of tiers; track tier) {
      <mat-option [value]="tier">
        <span class="mat-option">{{ tier }}</span>
      </mat-option>
    }
    <mat-select-trigger>
      <div class="trigger-container">
        {{ selectedTier ? selectedTier : '' }}
        @if (selectedTier) {
          <button mat-icon-button class="clear-button" (click)="selectedTier = null" aria-label="Clear Selected Tier">
            <mat-icon>close</mat-icon>
          </button>
        }
      </div>
    </mat-select-trigger>
  </mat-select>
</mat-form-field>
@if (showItemSelector) {
  <mat-form-field class="form-item-large" appearance="fill">
    <mat-label>{{ filteredItems.length }} items</mat-label>
    <mat-select [(ngModel)]="selectedItem">
      <mat-option>
        <ngx-mat-select-search ngModel (ngModelChange)="filterItems($event)" placeholderLabel="Search" noEntriesFoundLabel="No matches"></ngx-mat-select-search>
      </mat-option>
      @for (item of filteredItems.slice(0, itemSelectAmountOptions); track item) {
        <mat-option [value]="item">
          <span class="mat-option">{{ item.localizedName }}</span>
        </mat-option>
      }
      <mat-select-trigger>
        <div class="trigger-container">
          {{ selectedItem ? selectedItem.localizedName : '' }}
          @if (selectedItem) {
            <button mat-icon-button class="clear-button" (click)="selectedItem = null" aria-label="Clear Selected Item">
              <mat-icon>close</mat-icon>
            </button>
          }
        </div>
      </mat-select-trigger>
    </mat-select>
  </mat-form-field>
}
